<template>
  <van-row class="dealerInfoBox">
    <van-col :span="colLabelSpanCom"
      ><span class="colLabel">
        <slot name="colLabel">可使用经销商</slot>
      </span></van-col
    >
    <van-col :span="colValSpan">
      <!-- 经销商名称 -->
      <div class="fvlr" @click="changeShowNUm">
        <slot name="currentDealerBox">
          <div v-if="dealer.name" class="dealerName ellipsis">
            <slot name="currentDealer">{{ dealer.name }}</slot>
          </div>
          <div v-else class="noDealer">
            <slot name="noDealer">请选择经销商</slot>
          </div>
          <van-icon name="arrow" />
        </slot>
      </div>
      <!-- 经销商地址 -->
      <div class="fvlr" v-if="dealer.name">
        <slot name="afterName">
          <div class="dealerLocationBox" @click="changeShowNUm">
            <p class="dealerLocation">
              {{ dealer.address }}
            </p>
          </div>
          <a :href="`tel:${dealer.tel}`">
            <van-icon class="phone" name="phone" />
          </a>
        </slot>
      </div>
    </van-col>
  </van-row>
  <teleport to="#useDialog">
    <SwitchDealer :from="from" :isShowPhone="isShowPhone" :showNum="showNum" @dealerFn="dealerFn" :orderTypeFlag="param?.orderData?.orderTypeFlag" />
  </teleport>
</template>

<script>
import { reactive, toRefs, onMounted, watch, onUnmounted, nextTick, computed } from 'vue'
import SwitchDealer from '@/components/canUseDealer/SwitchDealer'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { showToast } from '@/util/couponCollection'
export default {
  components: {
    SwitchDealer
  },
  props: ['from', 'isShowPhone', 'updataDealer', 'param', 'colLabelSpan'],
  emits: ['setLoading', 'useclick'],
  setup(props, { emit }) {
    const mountEle = document.createElement('div')
    mountEle.id = 'useDialog'
    !document.getElementById('useDialog') && document.body.appendChild(mountEle)
    onUnmounted(() => {
      // 清空节点
      // document.body.removeChild(mountEle)
    })
    let { from, isShowPhone, updataDealer, param, colLabelSpan } = toRefs(props)
    let route = useRoute()
    const store = useStore()
    let { loyaltyType } = store.state.currentGoodsInfo
    const state = reactive({
      loyaltyType: loyaltyType,
      showNum: 0,
      from,
      isShowPhone,
      updataDealer,
      colLabelSpan,
      param,
      dealer: store.state.dealerInfo || {}
    })
    const colLabelSpanCom = computed(() => (state.colLabelSpan ? state.colLabelSpan : 7))
    const colValSpan = computed(() => 24 - colLabelSpanCom.value)
    const changeShowNUm = () => {
      // if(loyaltyType==2) return false
      // console.log('changeShowNUm-------', state.param)
      store.commit('SETLOYALTYAPPLYdEALERPARAM', state.param)
      if (state.param && state.param.useclick === false) {
        // 不提交点击事件
      } else if (!state.param || !state.param.loyaltyId || !state.param.gsCode) {
        emit('useclick', state.param)
        return
      }
      nextTick(() => {
        state.showNum += 1
      })
    }
    const showPop = () => {
      // console.log('showPop', state.param)
      store.commit('SETLOYALTYAPPLYdEALERPARAM', state.param)
      nextTick(() => {
        state.showNum += 1
      })
    }
    const dealerFn = val => {
      // state.dealer = val
      // state.hasDealer = true
    }

    onMounted(() => {})

    return {
      ...toRefs(state),
      dealerFn,
      colLabelSpanCom,
      colValSpan,
      showPop,
      changeShowNUm
    }
  }
}
</script>

<style lang="scss" scoped>
.dealerInfoBox {
  margin-bottom: 14px;
}
.colLabel {
  font-size: 14px;
  color: #333;
  // line-height: 30px;
  font-weight: bold;
}

.circle {
  padding: 1px 8px;
  margin-right: 16px;
  border: 1px solid#666;
  border-radius: 5px;
  font-size: 12px;
}
.circleActive {
  border-color: rgb(48, 136, 197);
  color: rgb(48, 136, 197);
}
.dealerLocation {
  margin: 10px 0;
  font-size: 13px;
  color: #666;
  line-height: 18px;
}
.phone {
  font-size: 24px;
  color: #3088c5;
  transform: rotate(-90deg);
}

.dealerName {
  font-size: 14px;
  color: #333;
  font-weight: 700;
}
.noDealer {
  font-size: 14px;
  color: #999999;
}
.dealerLocationBox {
  width: calc(100% - 40px);
  font-size: 13px;
  i {
    font-size: 50px;
  }
}
.salesVolume {
  font-size: 13px;
  color: #3088c5;
}
</style>
